import { calculateWeighting } from 'src/utils/weighting/calculateWeighting'
import { AnimalHistoric, AnimalHistoricParams } from 'src/domain/animal/AnimalHistoric'
import { AnimalProductive } from 'src/domain/animal/ProductiveAnimal'
import { IAnimal } from 'src/dto/animal.dto'

interface Params {
  productiveAnimalHistoric: any[]
  formData: Partial<IAnimal> & AnimalHistoricParams

  createProductive: (data: any) => Promise<any>
  createHistoric: (data: AnimalHistoricParams) => Promise<any>
}

export const calculateAndSaveProductiveAndHistoric = async ({
  productiveAnimalHistoric,
  formData,
  createProductive,
  createHistoric
}: Params) => {
  const now = new Date()

  const { gpd, gpm, inter, lastWeightEntry } = calculateWeighting({
    productiveAnimalHistoric,
    newWeight: formData.pesoAtual!,
    newDate: now.toISOString()
  })

  const historic = new AnimalHistoric({
    idAnimal: formData.idAnimal!,
    idFazenda: formData.idFazenda!,
    peso: formData.pesoAtual!,
    observacoes: formData.observacoes || '',
    fitaComprimento: formData?.fitaComprimento,
    fitaPerimetro: formData.fitaPerimetro,
    perimetro: formData.perimetro,
    idFazendaIdAnimal: `${formData.idFazenda}#${formData.idAnimal}`
  })

  const productive = new AnimalProductive({
    idFazenda: formData.idFazenda!,
    idAnimal: formData.idAnimal!,
    idLote: formData.idLoteAtual || '',
    nome: formData.nome || '',
    peso: formData.pesoAtual!,
    gpd,
    gpm,
    inter,
    idadeDias: formData?.dataNascimento
      ? Math.floor((now.getTime() - new Date(formData.dataNascimento).getTime()) / (1000 * 60 * 60 * 24))
      : 0,
    perimetro: formData.perimetro,
    pesoAnterior: lastWeightEntry ? lastWeightEntry.peso : undefined
  })

  if (lastWeightEntry) {
    const isSameDay = new Date(lastWeightEntry.data).toDateString() === now.toDateString()

    if (isSameDay) {
      productive.data = lastWeightEntry.data
      productive.idProdutivo = lastWeightEntry.idProdutivo
    }
  }

  await createProductive(productive)
  await createHistoric(historic as AnimalHistoricParams)
}
